<script lang="ts">
	import { modalStore } from '@skeletonlabs/skeleton';
	import { MagnifyingGlass } from '@svg';
	import SearchModal from './SearchModal.svelte';

	// Trigger forms
	const triggerCategoryFormPrompt = (): void => {
		modalStore.trigger({
			type: 'component',
			component: { ref: SearchModal }
		});
	};
</script>

<button class="btn sticky variant-glass-secondary w-min bottom-4 ml-auto" on:click={triggerCategoryFormPrompt}>
	<MagnifyingGlass />
</button>
